import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerUpRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowCornerUpRight"><Path d="M3.5 19.5V9H20" stroke="currentColor" strokeLinecap="square"/><Path d="M16 13.5L20.5 9L16 4.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowCornerUpRight;
